import { router } from 'expo-router';

import type { Command } from './types';

export const newAssociationCommand: Command = {
	id: 'new-association',
	title: 'New Association',
	description: 'Create a new association',
	icon: 'business-outline',
	category: 'create',
	keywords: ['association', 'property', 'client', 'customer'],
	action: (closeSearch) => {
		router.push('/associations/new');
		closeSearch?.();
	},
};
